import { render } from "./RiskLegend.vue?vue&type=template&id=92c30ca0&scoped=true"
import script from "./RiskLegend.vue?vue&type=script&lang=js"
export * from "./RiskLegend.vue?vue&type=script&lang=js"

import "./RiskLegend.vue?vue&type=style&index=0&id=92c30ca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92c30ca0"]])

export default __exports__